import { useEffect, useState } from "react";
import { getContent, saveContent } from "../lib/content";
import { isAlly } from "../lib/theme";

const DEFAULT_ITEMS = [
  "Sewer frequency detected",
  "No phones",
  "Strict dress code: RAT RAT RAT",
  "Leave your cat at home",
  "Bring your own tail",
  "Location encrypted",
];

const DEFAULT_ALLY_ITEMS = [
  "Fruit mode engaged",
  "Bumps Bumps Bumps 8===D",
  "Jungle juice patrol",
  "Taste the rainbow pit",
  "Rush hour, all night",
  "Still no cats",
];

export const Marquee = () => {
  const [texts, setTexts] = useState({ items: DEFAULT_ITEMS, items_ally: DEFAULT_ALLY_ITEMS });
  const [editing, setEditing] = useState(false);
  const [ally, setAllyState] = useState(isAlly);

  useEffect(() => {
    getContent("marquee").then((v) => {
      if (v) {
        setTexts((t) => ({
          items: Array.isArray(v.items) && v.items.length ? v.items : t.items,
          items_ally: Array.isArray(v.items_ally) && v.items_ally.length ? v.items_ally : t.items_ally,
        }));
      }
    });
  }, []);

  useEffect(() => {
    const onEdit = (e) => setEditing(e.detail.editing);
    const onTheme = (e) => setAllyState(e.detail.ally);
    window.addEventListener("rotu:edit", onEdit);
    window.addEventListener("rotu:theme", onTheme);
    return () => {
      window.removeEventListener("rotu:edit", onEdit);
      window.removeEventListener("rotu:theme", onTheme);
    };
  }, []);

  const activeKey = ally ? "items_ally" : "items";
  const activeItems = texts[activeKey];

  const updateItem = (i, el) => {
    const value = el.innerText.replace(/\/+/g, "").trim();
    if (!value || value === activeItems[i]) return;
    const next = { ...texts, [activeKey]: activeItems.map((it, idx) => (idx === i ? value : it)) };
    setTexts(next);
    saveContent("marquee", next);
  };

  const row = [...activeItems, ...activeItems];
  return (
    <div
      className="relative z-10 border-y border-white/10 bg-[#0D0D13]/80 backdrop-blur-sm py-4 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <div
        className="animate-marquee flex whitespace-nowrap w-max"
        style={editing ? { animationPlayState: "paused" } : {}}
      >
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className={`mx-8 text-xs sm:text-sm tracking-[0.35em] uppercase text-zinc-500 ${editing ? "editable-box" : ""}`}
                contentEditable={editing}
                suppressContentEditableWarning
                onBlur={(e) => updateItem(i % activeItems.length, e.currentTarget)}
                data-testid={half === 0 ? `marquee-item-${i % activeItems.length}` : undefined}
              >
                {item} <span className="text-[#FF0055] ml-8" contentEditable={false}>///</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
